export const numberFilterHandler = (filter, fieldName, value) => {
  if (isNaN(value) || value === '') {
    delete filter.current[fieldName]
    return
  }
  filter.current[fieldName] = Number(value)
}
